export const isTokenExpired = token => {
  console.log('Verificando si el token ha expirado:', token);

  if (!token) {
    console.log('No hay token. Asumiendo que ha expirado.');
    return true; // Si no hay token, asume que ha expirado
  }

  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('El token no tiene el formato correcto.');
      return true; // Si el token no tiene el formato correcto, asume que ha expirado
    }

    const { exp } = JSON.parse(atob(parts[1])); // Decodifica el payload del JWT
    const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
    console.log('Exp:', exp, 'Current Time:', currentTime); // Logs para depuración
    const isExpired = exp < currentTime;
    console.log('¿El token ha expirado?', isExpired);
    return isExpired; // Retorna true si el token ha expirado
  } catch (error) {
    console.error('Error al verificar el token:', error);
    return true; // Si hay un error, asume que el token ha expirado
  }
};
